module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/petition/petition-approval-grid/petition-approval-grid.component.css
// module id = ./src/app/petition/petition-approval-grid/petition-approval-grid.component.css
// module chunks = main